import { AnimatePresence } from 'framer-motion'
import React from 'react'
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch
} from 'react-router-dom'
import OfflineToast from '../component/OfflineToast'
import Login from '../pages/Login'
import ProvidersWrapper from '../providers/ProvidersWrapper'
import AppRouter from './AppRouter'
import ConfigRouter from './ConfigRouter'
import { PrivateRoute } from './privateRoute'

const Routes: React.FC = () => {
  return (
    <ProvidersWrapper>
      <Router>
        <OfflineToast />
        <AnimatePresence exitBeforeEnter>
          <Switch>
            <Redirect exact from="/" to="/nav" />
            <PrivateRoute path="/nav" component={AppRouter} />
            <PrivateRoute path="/configuracao" component={ConfigRouter} />
            <Route exact path="/login" component={Login} />
          </Switch>
        </AnimatePresence>
      </Router>
    </ProvidersWrapper>
  )
}

export default Routes
